import { render, staticRenderFns } from "./sToolbarPerson.vue?vue&type=template&id=0d91dcdc"
import script from "./sToolbarPerson.vue?vue&type=script&lang=js"
export * from "./sToolbarPerson.vue?vue&type=script&lang=js"
import style0 from "./sToolbarPerson.vue?vue&type=style&index=0&id=0d91dcdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports